import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { formatISO, isAfter, isBefore, isSameDay, isWithinInterval } from 'date-fns';
import { memo } from 'react';
import { Day, Days as DaysUI, Weekday, Weekdays } from '../../../../primitives/index.js';
const DaysComponent = ({
  days,
  weekdays,
  minDate,
  maxDate,
  rangeStart,
  rangeHighlightStart,
  rangeEnd,
  rangeHighlightEnd,
  onDayClick,
  onDayMouseEnter,
  onDayMouseLeave,
  onDayFocus,
  onDayBlur
}) => _jsxs(_Fragment, {
  children: [_jsx(Weekdays, {
    children: weekdays.map(({
      label,
      weekend
    }) => _jsx(Weekday, {
      weekend: weekend,
      children: label
    }, label))
  }), _jsx(DaysUI, {
    children: days.map(({
      label,
      date
    } = {}, index) => {
      if (!date || isBefore(date, minDate) || isAfter(date, maxDate)) {
        return _jsx(Day, {
          disabled: true,
          children: label
        }, label || index);
      }
      const selected = Boolean(rangeStart && isSameDay(date, rangeStart) || rangeEnd && isSameDay(date, rangeEnd));
      const inRange = Boolean(rangeHighlightStart && rangeHighlightEnd && isWithinInterval(date, {
        start: rangeHighlightStart,
        end: rangeHighlightEnd
      }));
      return _jsx(Day, {
        selected: selected,
        inRange: inRange,
        "data-date": formatISO(date, {
          representation: 'date'
        }),
        onClick: onDayClick,
        onMouseEnter: onDayMouseEnter,
        onMouseLeave: onDayMouseLeave,
        onFocus: onDayFocus,
        onBlur: onDayBlur,
        // Safari 14 fix
        onMouseDown: onDayMouseEnter,
        onMouseUp: onDayMouseLeave,
        children: label
      }, label);
    })
  })]
});
export const Days = memo(DaysComponent);